module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/economic-group-flow/component/economic-group-flow/economic-group-flow.component.scss
// module id = ./src/app/economic-group-flow/component/economic-group-flow/economic-group-flow.component.scss
// module chunks = main